import TemplateGlobal from '@src/components/Layout/TemplateGlobal'
import type { JSX } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import DviPage from './Dvi/DviPage'
import ExceptionPage from './Exception/ExceptionPage'
import HomePage from './Home/HomePage'
import ImportPage from './Import/ImportPage'
import LeadTimePage from './LeadTime/LeadTimePage'
import PersonRouter from './Person/PersonRouter'
import TechDebtPage from './TechDebt/TechDebtPage'

const Router = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<TemplateGlobal />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/exceptions" element={<ExceptionPage />} />
          <Route path="/people/*" element={<PersonRouter />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/leadtime" element={<LeadTimePage />} />
          <Route path="/dvi" element={<DviPage />} />
          <Route path="/techdebt" element={<TechDebtPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
